<template>
  <div
    v-if="+systemConfig.theme_type !== 4"
    class="todo-list-warp"
    @scroll="scrollEvent"
  >
    <div
      class="list-item"
      v-for="(item, index) in list"
      :key="index"
      @click.stop="handleClick(item)"
    >
      <div class="info-warp">
        <div
          :class="{ 'before-border': true }"
          :style="{
            backgroundColor: stateList.find((s) => s.value === +item.status)
              ?.backgroundColor,
          }"
        ></div>
        <div class="info-text-warp">
          <div class="line-1">
            <div class="line-title">
              <div class="info-title">
                {{ item.object_name }} |
                {{ item.title }}
              </div>
            </div>
            <p
              class="status"
              :class="filterStatus(item.status).class"
              :style="{
                backgroundColor: stateList.find((s) => s.value === +item.status)
                  ?.color,
              }"
            >
              {{ stateList.find((s) => s.value === +item.status)?.label }}
            </p>
          </div>
          <div class="line-2">
            <p class="project-name">项目：{{ item.archi_name }}</p>
          </div>
          <div class="line-2">
            <p class="project-info">
              上一步处理人：
              <img
                class="avatar"
                :src="
                  item.user_avatar ||
                  'https://dwh_api.bimcc.net/uploads/202301/17/1673943165_C8E5tNmVgm.png'
                "
                alt=""
              />{{ item.user_name }}
            </p>
            <p
              :class="{
                'time-status': true,
                [filterTime(item.endDate).class]: true,
              }"
            >
              {{ filterTime(item.endDate).time }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <Empty
      v-if="list.length === 0"
      description="暂无数据"
      :image-size="100"
    ></Empty>
  </div>
  <div class="four-todo" v-else>
    <div
      class="item"
      v-for="(item, index) in list"
      :key="index"
      @click.stop="handleClick(item)"
    >
      <div class="top">
        <div class="left">
          <div class="name">{{ item.object_name }}</div>
          <div class="status" :class="filterStatus(item.status).class">
            {{ filterStatus(item.status).label }}
          </div>
        </div>
        <div class="right">
          <img
            src="https://openim-1309784708.cos.ap-shanghai.myqcloud.com/af3ccbee493ceb8b99120f0946980aa4.png"
            alt=""
          />
          {{ item.from_user_name }}>我
        </div>
      </div>
      <div class="bottom">
        <div class="project">项目：{{ item.archi_name }}</div>
        <div class="date">{{ item.startDate }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { format } from 'date-fns';
import { Empty } from 'element-ui';
import { mapState } from 'vuex';
export default {
  components: {
    Empty,
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
      require: true,
    },
  },
  computed: {
    ...mapState(['systemConfig']),
  },
  data() {
    return {
      stateList: [
        {
          value: -1,
          label: '退回',
          color: '#FFECEC',
          backgroundColor: 'rgba(255, 198, 198, 1)',
        },
        {
          value: 0,
          label: '发起',
          color: '#DFF7E5',
          backgroundColor: 'rgba(125, 234, 164, 1)',
        },
        {
          value: 1,
          label: '审核中',
          color: '#E7F0FE',
          backgroundColor: 'rgba(165, 199, 254, 1)',
        },
        {
          value: 2,
          label: '完成',
          color: '#F0F1F4',
          backgroundColor: '#707786',
        },
        {
          value: 3,
          label: '审核中',
          color: '#E7F0FE',
          backgroundColor: 'rgba(165, 199, 254, 1)',
        },
        {
          value: 4,
          label: '审核中',
          color: '#E7F0FE',
          backgroundColor: 'rgba(165, 199, 254, 1)',
        },
        {
          value: 5,
          label: '完成',
          color: '#F0F1F4',
          backgroundColor: '#707786',
        },
        {
          value: 6,
          label: '拒绝',
          color: '#FFECEC',
          backgroundColor: 'rgba(255, 198, 198, 1)',
        },
        {
          value: 7,
          label: '作废',
          color: '#F0F1F4',
          backgroundColor: '#707786',
        },
      ],
    };
  },
  methods: {
    handleClick(item) {
      console.log(item);
      let data = {
        event: 'showDetailModal',
        form_uuid: item.form_id,
        flow_id: item.flow_id,
        data_id: item.id,
        tag: 'check',
        module_name: item.module_name,
        object_name: item.object_name,
      };
      window.parent.postMessage(data, '*');
      return;
    },
    filterIcon(text) {
      if (!text || text.length === 0) {
        return {
          text: '-',
          class: '',
        };
      }
      const str = text[0];
      const classHash = {
        安: 's-icon',
        质: 'q-icon',
        进: 'p-icon',
      };
      return {
        text: str,
        class:
          classHash[str] ||
          classHash[
            Object.keys(classHash)[
              Math.floor(Math.random() * Object.keys(classHash).length)
            ]
          ],
      };
    },
    filterStatus(status) {
      switch (status + '') {
        case '-1': {
          return {
            label: '退回',
            class: 't-status',
          };
        }
        case '6': {
          return {
            label: '拒绝',
            class: 't-status',
          };
        }
        case '0': {
          return {
            label: '发起',
            class: 'f-status',
          };
        }
        case '1':
        case '3':
        case '4': {
          return {
            label: '审核中',
            class: 's-status',
          };
        }
        case '2':
        case '5': {
          return {
            label: '完成',
            class: 'w-status',
          };
        }
        case '7': {
          return {
            label: '作废',
            class: 'w-status',
          };
        }
        default: {
          return {
            label: '发起',
            class: 'f-status',
          };
        }
      }
    },
    filterTime(time) {
      const targetDate = new Date(time);
      if (isNaN(targetDate.getTime())) {
        return {
          time: '-',
          className: '',
          str: '',
        };
      } else {
        return this.timeFormat(time);
      }
    },
    // 时间格式化
    timeFormat(time) {
      if (!this.nowDateObj) {
        this.nowDateObj = new Date();
      }
      const targetDate = new Date(time);
      const diffTime = this.nowDateObj.getTime() - targetDate.getTime();
      if (diffTime > 24 * 3600 * 1000) {
        return {
          time: `逾期${Math.floor(diffTime / (24 * 3600 * 1000))} 天`,
          class: 'w-status',
          str: '已滞后',
        };
      }
      const ny = this.nowDateObj.getFullYear();
      const ty = targetDate.getFullYear();
      const nm = this.nowDateObj.getMonth();
      const tm = targetDate.getMonth();
      const nd = this.nowDateObj.getDate();
      const td = targetDate.getDate();
      if (ny === ty) {
        if (nm === tm) {
          if (nd === td) {
            return {
              time: `今天${format(targetDate, 'HH:mm')}截止`,
              class: 's-status',
              str: '待处理',
            };
          } else if (td - nd === 1) {
            return {
              time: `明天${format(targetDate, 'HH:mm')}截止`,
              class: 'p-status',
              str: '待处理',
            };
          } else {
            return {
              time: `${format(targetDate, 'MM-dd HH:mm')}截止`,
              class: 'p-status',
              str: '待处理',
            };
          }
        } else {
          return {
            time: `${format(targetDate, 'MM-dd HH:mm')}截止`,
            class: 'p-status',
            str: '待处理',
          };
        }
      } else {
        return {
          time: `${format(targetDate, 'yyyy-MM-dd HH:mm:ss')}截止`,
          class: 'p-status',
        };
      }
    },
    scrollEvent(e) {
      this.$emit('send-scroll-event', e);
    },
    refresh(e) {
      if (e.data.event === 'close-todo-list-form') {
        this.$emit('refreshList', true);
      }
    },
  },
  mounted() {
    window.addEventListener('message', this.refresh);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.refresh);
  },
};
</script>

<style lang="less" scoped>
.todo-list-warp {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .list-item {
    width: 100%;
    display: flex;
    padding: 12px 22px;
    box-sizing: border-box;
    align-items: flex-end;
    cursor: pointer;
    &:hover {
      background: #f5f5f5;
      border-radius: 3px;
    }
    .info-warp {
      flex-grow: 1;
      width: 100px;
      display: flex;
      position: relative;
      .before-border {
        position: absolute;
        width: 2px;
        height: 62px;
        left: -12px;
        top: 50%;
        border-radius: 2px;
        transform: translateY(-50%);
      }
      .info-icon {
        flex-shrink: 0;
        height: 36px;
        width: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 6px;
        font-size: 22px;
        font-family: YouSheBiaoTiHei;
      }
      .q-icon {
        background: rgba(90, 204, 120, 0.2);
        color: #5acc78;
      }
      .s-icon {
        background: rgba(255, 170, 74, 0.2);
        color: #ffaa4a;
      }
      .p-icon {
        background: rgba(51, 187, 255, 0.2);
        color: #33bbff;
      }
      .other-icon {
        background: #f1f1f1;
      }
      .info-text-warp {
        // margin-left: 12px;
        flex-grow: 1;
        width: 100px;
        gap: 4px;
        display: flex;
        flex-direction: column;
        .line-1 {
          width: 100%;
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          // justify-content: space-between;
          .line-title {
            // flex: 1;
            overflow: hidden;
            position: relative;
            height: 22px;
            margin-right: 8px;
          }
          .info-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #292f3d;
            line-height: 22px;
            // display: inline-block;
            white-space: nowrap;
            // position: absolute;
            left: 0px;
            // &:hover {
            //   animation: 5s todayScroll linear infinite;
            // }
          }

          .status {
            flex-shrink: 0;
            margin-left: 8px;
            height: 22px;
            padding: 0 12px;
            box-sizing: border-box;
            border-radius: 6px;
            line-height: 22px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 500;
            white-space: normal;
          }
          .t-status {
            background: #ffecec;
            color: #e0452d;
          }
          .f-status {
            background: #dff7e5;
            color: #21a35d;
          }
          .s-status {
            color: #0088cc;
            background: #e7f0fe;
          }
          .w-status {
            color: #596058;
            background: #f0f1f4;
          }
        }
        .line-2 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 2px;
          height: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #6d768f;
          line-height: 18px;
          .project-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex-grow: 1;
            width: 10px;
          }
          .time-status {
            flex-shrink: 0;
            white-space: nowrap;
            height: 18px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6d788f;
            line-height: 18px;
            margin-right: 5px;
          }
          .w-status {
            color: #e0452d;
          }
          .avatar {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            overflow: hidden;
          }
          .project-info {
            display: flex;
            align-items: center;
            gap: 6px;
          }
        }
      }
    }
    // .time-status{
    //     flex-shrink: 0;
    //     white-space: nowrap;
    //     height: 18px;
    //     font-size: 12px;
    //     font-family: PingFangSC-Regular, PingFang SC;
    //     font-weight: 400;
    //     color: #6D788F;
    //     line-height: 18px;
    //     margin-right: 5px;
    // }
  }
}
@keyframes todayScroll {
  0% {
    left: 0%;
  }

  100% {
    left: -35%;
  }
}
.four-todo {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  overflow: auto;
  width: -webkit-fill-available;
  .item {
    display: flex;
    padding: var(--spacing-6, 12px) 14px;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-3, 6px);
    align-self: stretch;
    border-radius: 12px;
    border: 1px solid #f9f6f4;
    background: var(--overall-surface-default, #fff);
    &:hover {
      border-radius: 12px;
      border: 1px solid #f9f6f4;
      background: linear-gradient(
        180deg,
        rgba(247, 171, 25, 0) 2.19%,
        rgba(242, 119, 19, 0.1) 52.39%,
        rgba(231, 0, 6, 0.1) 98.44%
      );
    }
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .left {
        overflow: hidden;
        color: var(--text-on-surface-primary, #181b22);
        text-overflow: ellipsis;

        /* web/cn/helper/helper-03 */
        font-family: 'PingFang SC';
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 153.846% */
        letter-spacing: 0.4px;
        display: flex;
        .name {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .status {
        flex-shrink: 0;
        margin-left: 8px;
        height: 20px;
        padding: 0 8px;
        box-sizing: border-box;
        border-radius: 12px;
        line-height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        white-space: normal;
      }
      .w-status {
        background: #fff1f1;
        color: #e0452d;
      }
      .s-status {
        background: #e1f5e7;
        color: #21a35d;
      }
      .p-status {
        color: #0088cc;
        background: #e0f4ff;
      }
      .d-status {
        color: #007d79;
        background: #e1f7f6;
      }
      .right {
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: var(--text-on-surface-tertiary, #707786);
      width: 100%;
      /* web/cn/helper/helper-02 */
      font-family: 'PingFang SC';
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 18px */
      letter-spacing: 0.4px;
    }
  }
}
</style>
